import axios from "../../../core/api/http-common";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../../app/store/slices/authSlice";

const REFRESH = "/auth/refresh";

const useRefreshToken = () => {
  const dispatch = useDispatch();

  const refresh = async () => {
    const response = await axios.get(REFRESH, { withCredentials: true });

    dispatch(
      setCredentials({
        accessToken: response.data.accessToken,
        sys_role: response.data.sys_role,
      })
    );

    return response.data.accessToken;
  };

  return refresh;
};

export default useRefreshToken;
